import { useDispatch } from "react-redux"
import { filterByPrice } from "../redux/actions"

const FilterPrice = ({ setOrder, setCurrentPage, order }) => {

  const dispatch = useDispatch();

  const handlePrice = (e) => {
    e.preventDefault();
    setOrder(e.target.value);
    dispatch(filterByPrice(order));
    setCurrentPage(1);
  };

  return (
    <>
      <select onChange={e => handlePrice(e)} className="border focus:outline-none focus:border-indigo-700 dark:border-gray-700 pl-3 py-3 shadow-sm bg-transparent rounded text-sm focus:outline-none focus:border-indigo-700 placeholder-gray-500 text-gray-500 dark:text-gray-400">
        <option hidden>Precio</option>
        <option value='lowest'>Más bajo</option>
        <option value='higher'>Más alto</option>
      </select>
      {/* <button onClick={e => handlePrice(e)} value="higher">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path d="M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h7a1 1 0 100-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM15 8a1 1 0 10-2 0v5.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L15 13.586V8z" />
        </svg>
      </button>
      Price
      <button onClick={e => handlePrice(e)} value="lowest">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path d="M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h5a1 1 0 000-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM13 16a1 1 0 102 0v-5.586l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L13 10.414V16z" />
        </svg>
      </button> */}
    </>
  );
};

export default FilterPrice;
